'use client'

import { useEffect, useState } from 'react'
import { auth } from '~/components/FirebaseProvider'
import { onAuthStateChanged, type User } from 'firebase/auth'
import { Button } from '~/app/_components/Button'
import { Container } from '~/app/_components/Container'
import { api } from '~/trpc/react'

export function CallToAction() {
  const [currentUser, setCurrentUser] = useState<User | null>(null)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    })

    return () => unsubscribe()
  }, [])

  const { data: userData } = api.post.getUserByFirebaseUid.useQuery(
    {
      firebaseUid: currentUser?.uid ?? '',
      email: currentUser?.email ?? undefined,
      displayName: currentUser?.displayName ?? undefined,
    },
    { enabled: !!currentUser?.uid },
  )

  const isCaregiver = !!userData?.Caregiver
  const ctaHref = isCaregiver ? '/app/jobs' : '/app/caregivers'
  const ctaLabel = isCaregiver ? 'Open job board' : 'See Care Professionals'
  const heading = isCaregiver
    ? 'Find your next role'
    : currentUser
      ? 'View Local Care Professionals'
      : 'Get started today'
  const subtext = isCaregiver
    ? 'Browse open positions that match your skills and schedule.'
    : currentUser
      ? 'Ready to find the perfect care professional for your loved ones?'
      : 'Join thousands of families who trust us to connect them with exceptional care professionals.'

  return (
    <section
      id="get-started-today"
      className="relative overflow-hidden bg-primary py-32"
    >
      <Container className="relative">
        <div className="mx-auto max-w-lg text-center">
          <h2 className="font-display text-3xl tracking-tight text-white sm:text-4xl">
            {heading}
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-white">
            {subtext}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button
              href={currentUser ? ctaHref : '/join'}
              variant="solid"
              color="secondary"
            >
              {currentUser ? ctaLabel : 'Get 6 months free'}
            </Button>
          </div>
        </div>
      </Container>
    </section>
  )
}
